import styled from '@emotion/styled';
import { Badge } from 'antd';

export const STitle = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;

  color: rgba(0, 0, 0, 0.85);
`;

export const SHeader = styled.div`
  margin-top: 24px;
`;

export const SContent = styled.div`
  margin-top: 24px;
  background-color: white;
  flex-grow: 1;
`;

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const STabs = styled.div`
  position: relative;
  .ant-tabs {
    .ant-tabs-nav {
      margin: 0;
    }
    .ant-tabs-tab {
      padding: 17px 0;

      .ant-tabs-tab-btn {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
`;

export const SDangerActionItem = styled.div`
  color: #ff4d4f;
`;

export const SStatusCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 90px;
`;

export const STableContainer = styled.div`
  .statistic-table {
    .ant-table-row-expand-icon-cell {
      max-width: 40px;
    }
    .ant-table-expanded-row > td {
      padding: 0;
    }
  }
  .tab-cyan {
    border-color: cyan;
  }
`;

export const STabBadge = styled(Badge)`
  position: relative;
  bottom: 1px;
`;
